export default "__VITE_ASSET__ciXE5bGj__"